import React from 'react';
import DeviceRelativeTimeCell from "../device/DeviceRelativeTimeCell";

const DateToStr = ({date, newLine = true}) => {
    return (
        <DeviceRelativeTimeCell value={date} useBr={newLine}/>
    )
}
export default DateToStr;